/* eslint-disable quotes */
import dayjs from 'dayjs';

export default {
  NICK_NICKELS: {
    fullName: 'Nick Nickels',
    image: '/assets/leading/left.png',
    text: dayjs().diff('1998-12-28', 'years') + " Jahre alt",
    socials: {
      instagram: 'air_nj',
      snapchat: 'nickels_nick',
      linkedin: 'nick-nickels'
    }
  },
  ULLRICH_WEICHERT: {
    fullName: 'Ullrich Weichert',
    image: '/assets/leading/center.png',
    text: dayjs().diff('1984-09-07', 'years') + " Jahre alt",
    socials: {
      instagram: 'ullrichweichert',
      snapchat: '',
      linkedin: 'ullrich-weichert'
    }
  },
  TIMM_VOLLBORN: {
    fullName: 'Timm Vollborn',
    image: '/assets/leading/right.png',
    text: dayjs().diff('1999-01-30', 'years') + ' Jahre alt',
    socials: {
      instagram: 'timm.vollborn',
      snapchat: 'timm.vollborn',
      linkedin: 'timm-vollborn'
    }
  },
};
